function updateNavFixedClass() {
  const scrollThreshold = 10;

  const isScrolled = window.scrollY > scrollThreshold;

  if (isScrolled) {
    document.body.classList.add('nav-fixed');
  } else {
    document.body.classList.remove('nav-fixed');
  }
}

let ticking = false;

function onScroll() {
  if (!ticking) {
    requestAnimationFrame(() => {
      updateNavFixedClass();
      ticking = false;
    });
    ticking = true;
  }
}

window.addEventListener('load', () => {
  requestAnimationFrame(updateNavFixedClass);
});

window.addEventListener('scroll', onScroll);

document.addEventListener('DOMContentLoaded', function () {
  /* -------------------------------------
    Cookie Modal JS
  -------------------------------------- */
  // Close cookie modal
  document.addEventListener('click', function (e) {
    if (e.target.closest('.j-close-cookie')) {
      e.preventDefault();
      e.target.closest('.cookie-modal').classList.remove('active');
      document.cookie = 'cookie_box=true; max-age=' + 60 * 60 * 24 * 365 + '; path=/'; // expires in 365 days
    }
  });

  // Check if cookie_box is already set
  function getCookie(name) {
    let match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    if (match) return match[2];
  }

  var cookie_box = getCookie('cookie_box');
  if (cookie_box === undefined) {
    console.log('cookie_box undefined');
    setTimeout(function () {
      document.querySelector('.cookie-modal').classList.add('active');
    }, 3000);
  }
  /* -------------------------------------
    Cookie Modal JS
  -------------------------------------- */
  
  /* -------------------------------------
      Detail page `Enquire` button click JS
  -------------------------------------- */
  const enquireBtnSection = document.querySelector('[data-block-type="custom-more-info-button"]');
  if(enquireBtnSection){
    enquireBtnSection.addEventListener('click', function (event) {
      event.preventDefault(); // prevents link from navigating or scrolling
      const link = document.querySelector('[data-block-type="custom-more-info-button"] a');
      const targetId = link.getAttribute('href'); // e.g., "#product-extra-information"
      const targetElement = document.querySelector(targetId);

      if (targetElement) {
        targetElement.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }

      const productForm = document.querySelector('.product-form-builder');
      if (productForm) {
        const accordion = productForm.closest('.accordion__disclosure');
        if (accordion) {
          accordion.setAttribute('open', '');
          accordion.setAttribute('aria-expanded', 'true');
        }
        productForm.style.opacity = '1';
      }
    });
  }
  /* -------------------------------------
    Detail page `Enquire` button click JS
  -------------------------------------- */

  /* -------------------------
    Vacancies apply link JS
  ---------------------------- */
  const email = document.querySelector(`.careers-job-listings`);

  if(email != null){
    const senderEmail = email.dataset.sendermail;

    document.querySelectorAll(".apply-link").forEach(link => {
      const vacancyName = link.getAttribute("data-vacancyname") || "";

      const subject = encodeURIComponent(`Application for the position: ${vacancyName}`);
      const body = encodeURIComponent(`Hi Hiring Team,

  I hope this message finds you well. I am writing to express my interest in the position of "${vacancyName}".

  Please find my details below for your consideration:

  Full Name:
  Email:
  Phone Number:
  Residential Address:

  Thank you for your time and consideration. I look forward to the opportunity to contribute to your team.

  Best regards,
  [Your Full Name]`);

      const mailtoLink = `mailto:${senderEmail}?subject=${subject}&body=${body}`;
      link.setAttribute("href", mailtoLink);
    });
  }
  /* --------------------------
  Vacancies apply link JS
  ----------------------------- */

  /* -----------------------------------------------------
    Downloads page Show more button and expand collpase JS
  ------------------------------------------------------- */
  // Handle financial report year headings (fixed for your HTML structure)
  if(document.querySelectorAll('.statement-heading').length > 0){
    document.querySelectorAll('.statement-heading').forEach(function (heading) {
      heading.addEventListener('click', function () {
        const group = heading.getAttribute('data-group');
        const icon = heading.querySelector('.expand-icon');
        const content = document.querySelector('.financial-content[data-group="' + group + '"]');

        if (content) {
          const isHidden = content.classList.contains('hidden-row');
          if (isHidden) {
            content.classList.remove('hidden-row');
            icon.classList.add('open');
        } else {
            content.classList.add('hidden-row');
            icon.classList.remove('open');
          }
        }
      });

      // Add keyboard accessibility
      heading.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          heading.click();
        }
      });
    });
  }

  // Handle show more buttons (keep all other section logic unchanged)
  if(document.querySelectorAll('.show-more-btn').length > 0){
    document.querySelectorAll('.show-more-btn').forEach(function (button) {
      button.addEventListener('click', function () {
        const section = button.getAttribute('data-section');

        if (section === 'annual-report-rows') {
          const rows = document.querySelectorAll('.annual-report-rows .hidden-row');
          rows.forEach(function (row) {
            row.classList.remove('hidden-row');
            row.style.animation = 'fadeIn 0.5s ease-out';
          });
        } else if (section === 'presentation-report-rows') {
          const rows = document.querySelectorAll('.presentation-report-rows .hidden-row');
          rows.forEach(function (row) {
            row.classList.remove('hidden-row');
            row.style.animation = 'fadeIn 0.5s ease-out';
          });
        } else if (section === 'finance-report-rows') {
          // Show all financial report groups
          document.querySelectorAll('.statement-heading').forEach(function (heading) {
            const group = heading.getAttribute('data-group');
            const icon = heading.querySelector('.expand-icon');
            const content = document.querySelector('.financial-content[data-group="' + group + '"]');

            if (content) content.classList.remove('hidden-row');
            icon.classList.add('open');
          });
        }

        // Update button text and disable/remove it after use
        button.innerHTML = 'Loading... <span class="btn-icon"></span>';
        button.disabled = true;
        setTimeout(function () {
          button.style.display = 'none';
        }, 1000);
      });
    });
  }
  /* -----------------------------------------------------
    Downloads page Show more button and expand collpase JS
  ------------------------------------------------------- */
});
